import { Checkbox, Tooltip } from 'antd'
import React from 'react'
import { $t } from '~/i18n.js'

import { useSelector } from 'react-redux'
import { SleepHoogteEdit } from './SleepHoogteEdit.jsx'
import { CategorySelect } from './categorySelect.jsx'
import { clubHasFinance } from '~/featureMatrix.jsx'
import { VoucherSelector } from '~/components/voucher/VoucherSelector.jsx'
import { BookOutlined } from '@ant-design/icons'

export const SectionChecks = ({
  readOnly, editInstructorDetails,
  flight, saveFlight,
  sleepFlight, saveSleepFlight,
  gezagvoerder, tweedeInzittende
}) => {
  const { club } = useSelector((state) => state.persist)

  const inherit_sleep_cat = club.inherit_sleep_cat
  
  const hasFinance = clubHasFinance()

  const isInstructor = gezagvoerder && gezagvoerder.tag === 'instructeur' && flight.tweede_inzittende_naam
  const canExamen = flight.is_examen || (isInstructor && ['solist', 'dbo'].includes(tweedeInzittende && tweedeInzittende.tag))
  const canCheck = flight.is_training || (isInstructor && ['brevet', 'instructeur', 'basic_instructor'].includes(tweedeInzittende && tweedeInzittende.tag))

  // only instructors can adjust fis flights (or if the flight has been marked as that)
  const adjustFIS = flight.is_fis || (flight.tweede_inzittende_naam && gezagvoerder?.is_instructeur)
  // Usecase for solo/dbo students flying with unknown instructores
                                  || (flight.tweede_inzittende_naam && !gezagvoerder && flight.gezagvoerder_naam)
  
  const isGuestPilotOrInstructor = flight.tweede_inzittende_naam && !gezagvoerder && flight.gezagvoerder_naam || (gezagvoerder && gezagvoerder.is_instructeur)
  const adjustExam = flight.is_examen || (isGuestPilotOrInstructor && tweedeInzittende && ['solist', 'dbo'].includes(tweedeInzittende && tweedeInzittende.tag))
  const adjustProfOrTraining = flight.is_training || flight.is_profcheck || (isGuestPilotOrInstructor && tweedeInzittende && ['brevet', 'instructeur', 'basic_instructor'].includes(tweedeInzittende && tweedeInzittende.tag))

  const hasSleep = sleepFlight && sleepFlight.uuid
  
  const _saveTraining = (data) => {
    // ensure that if you check exam or checkstart, we must ensure it's also a FIS flight.
    // Some edgecases this is overruled elsewhere, as such if we check this we make sure that fis is also always assigned
    
    if (isInstructor && data.checked) {
      data.is_fis = true
      data.betalend_lid_id = flight.tweede_inzittende_id
      data.betalend_lid_2_id = 'DELETE'
    }
    saveFlight(data)
  }

  const _saveFIS = (data) => {
    // if not is_fis, and we have second pilot, the betalend id must become the first pilot
    if (data.is_fis) {
      data.betalend_lid_id = flight.tweede_inzittende_id
    } else {
      data.betalend_lid_id = flight.gezagvoerder_id
    }
    data.betalend_lid_2_id = 'DELETE'
    saveFlight(data)
  }

  return (
    <div className='column' style={{ alignItems: 'flex-start' }}>

      {hasFinance && (
         <div className='row' style={{ margin: '2px 0 6px', width: '100%', justifyContent: 'space-between' }}>
          <p className='label' style={{ marginRight: 2 }}><BookOutlined style={{marginRight: 1}} /> {$t('Bon')}</p>
          <VoucherSelector
            readOnly={readOnly}
            flight={flight}
            sleepFlight={sleepFlight}
            saveFlight={saveFlight}
            saveSleepFlight={saveSleepFlight}
          />
      </div>
      )
      }

      <CategorySelect
        readOnly={readOnly}
        currentFlight={flight.uuid}
        currentValue={flight.category}
        categories={(flight.start_methode === 'tmg' || flight.start_methode === 'sep') ? club.tmg_cat : club.flight_cat}
        onSelect={(value) => {
          if (readOnly) return
          saveFlight({ category: value })
          
          if (hasSleep && inherit_sleep_cat) {
            saveSleepFlight({ category: value })
          }
        }}
      />

      {hasSleep && !inherit_sleep_cat && <CategorySelect
        readOnly={readOnly}
        currentFlight={sleepFlight.uuid}
        currentValue={sleepFlight.category}
        categories={club.sleep_cat}
        onSelect={(value) => !readOnly && saveSleepFlight({ category: value })}
                   />}

      {hasSleep && <SleepHoogteEdit
        readOnly={readOnly} currentHeight={sleepFlight.height}
        saveHeight={(value) => saveSleepFlight({ height: value })}
                   />}

      {gezagvoerder && <Checkbox
        className='large' style={{ margin: '5px 0' }}
        checked={flight.is_overland} disabled={readOnly}
        onChange={(click) => !readOnly && saveFlight({ is_overland: click.target.checked })}
                       >
        <Tooltip
          placement='top'
          title={$t('Indien de vlucht aangemeld is voor overland')}
        >
          <p className='regular'>{$t('Overland')}</p>
        </Tooltip>
      </Checkbox>}

      {adjustFIS && <Checkbox
        className='large' style={{ margin: '5px 0' }}
        checked={flight.is_fis} disabled={readOnly && !editInstructorDetails}
        onChange={(click) => _saveFIS({ is_fis: click.target.checked })}
                    >
        <Tooltip
          placement='top'
          title={$t('Een FIS(S) vlucht is een instructievlucht uitgevoerd door een instructeur als PIC.')}
        >
          <p className='regular'>{$t('FI(S) vlucht')}</p>
        </Tooltip>
      </Checkbox>}

      {(adjustProfOrTraining || canCheck) && <Checkbox
        className='large' style={{ margin: '5px 0' }}
        checked={flight.is_training} disabled={readOnly && !editInstructorDetails}
        onChange={(click) => _saveTraining({ is_training: click.target.checked, checked: click.target.checked })}
                   >
        <Tooltip
          placement='top' disabled={readOnly}
          title={$t('Een trainingsvlucht is een EASA verplichting en voer je uit met een instructeur.')}
        >
          <p className='regular'>{$t('Trainingsvlucht')}</p>
        </Tooltip>
      </Checkbox>}

      {(adjustExam || canExamen) && <Checkbox
        className='large' style={{ margin: '5px 0' }}
        checked={flight.is_examen} disabled={readOnly && !editInstructorDetails}
        onChange={(click) => _saveTraining({ is_examen: click.target.checked, is_fis: click.target.checked ? true : flight.is_fis })}
                    >
        <Tooltip
          placement='top' disabled={readOnly}
          title={$t('Een examen vlucht om je brevet te halen.')}
        >
          <p className='regular'>{$t('Examen / Skill test')}</p>
        </Tooltip>
      </Checkbox>}

      {(adjustProfOrTraining || canCheck) && <Checkbox
        className='large' style={{ margin: '5px 0' }}
        checked={flight.is_profcheck} disabled={readOnly && !editInstructorDetails}
        onChange={(click) => !readOnly && _saveTraining({ is_profcheck: click.target.checked, is_fis: click.target.checked ? true : flight.is_fis })}
                   >
        <Tooltip
          placement='top' 
          disabled={readOnly}
          title={$t('Een prof-check is een examen om een verlopen brevet weer geldig te laten zijn.')}
        >
          <p className='regular'>{$t('Proficiency check')}</p>
        </Tooltip>
      </Checkbox>}

    </div>
  )
}
